import { ConnectionNames } from "../../../Contracts";
import { getRequestProps } from "../../../Common";
import { stringifyUrl } from "query-string";
export function CasinoRequestFormatter(message) {
    let { baseUrl, endpoint, method, headers, params } = getRequestProps(ConnectionNames.casino, message);
    const url = stringifyUrl({
        url: `${baseUrl}${endpoint}`,
        query: params
    }, {
        skipNull: true
    });
    return new Request(url, { method, headers });
}
//# sourceMappingURL=CasinoRequestFormatter.js.map